import * as components from './components'

export default [
  {
    path: '/course/:uuid',
    redirect: '/course/:uuid/dashboard'
  },
  {
    path: '/course/:uuid/about',
    component: components.CourseDetail,
    name: 'courseDetail',
    props: true
  },
  {
    path: '/course/:uuid/brokenlinks',
    component: components.BrokenLinks,
    name: 'brokenlinks',
    props: true
  },
  {
    path: '/course/:uuid/dashboard',
    component: components.CourseDashboard,
    name: 'courseDashboard',
    props: true
  },
  {
    path: '/microCompetencyMapping/upload',
    component: components.MicroCompetencyMappingUpload,
    name: 'microCompetencyMappingUpload',
    props: true
  },
  {
    path: '/course/:uuid/dashboard/instructor',
    component: components.CourseDashboardInstructor,
    name: 'courseDashboardInstructor',
    props: true
  },
  {
    path: '/course/:uuid/learn',
    component: components.CourseLearn,
    name: 'courseLearn',
    props: true
  },
  {
    path: '/course/:uuid/curate',
    component: components.CourseCuration,
    name: 'courseCuration',
    props: true
  },
    {
    path: '/course/:uuid/curatev2',
    component: components.CourseCurationMC,
    name: 'courseCurationMC',
    props: true
  },

  {
    path: '/course/:uuid/grade',
    component: components.ClassGrade,
    name: 'classGrade',
    props: true
  },
  {
    path: '/course/:uuid/performance',
    component: components.ClassPerformance,
    name: 'classPerformance',
    props: true
  },
  {
    path: '/course/:uuid/learn/:entityType/:entityUuid/about',
    component: components.EntityDetail,
    name: 'entityDetail',
    props: true
  },
  {
    path: '/course/:uuid/learn/:entityType/:entityUuid/about/selective',
    component: components.EntityDetailSR,
    name: 'entityDetailSR',
    props: true
  },
  {
    path: '/course/:uuid/aggregatedDignosticReport',
    component: components.AggregatedDignosticReport,
    name: 'aggregatedDignosticReport',
    props: true
  },
  {
    path: '/course/:uuid/assessmentId/:assessmentId/aggregatedDignosticTestReport',
    component: components.AggregatedDignosticTestReport,
    name: 'aggregatedDignosticTestReport',
    props: true
  },

  {
    path: '/course/:uuid/grading',
    component: components.Grading,
    name: 'grading',
    props: true
  },
  {
    path: '/course/:uuid/releaseLogic',
    component: components.ReleaseLogic,
    name: 'releaseLogic',
    props: true
  },
  {
    path: '/course/:uuid/learn/:entityType/:entityUuid/about/instructor',
    component: components.EntityDetailInstructor,
    name: 'entityDetailInstructor',
    props: true
  },
  {
    path: '/course/:uuid/learn/:entityType/:entityUuid',
    component: components.EntityLearn,
    name: 'entityLearn',
    props: true
  },
  {
    path: '/course/:uuid/learn/:entityType/:entityUuid/selective',
    component: components.EntityLearnSR,
    name: 'entityLearnSR',
    props: true
  },
  {
    path: '/course/:uuid/learn/:entityType/:entityUuid/instructor',
    component: components.EntityLearnInstructor,
    name: 'entityLearnInstructor',
    props: true
  },
  {
    path: '/course/:uuid/learn/:entityType/:entityUuid/assessment/:sessionId',
    component: components.AssessmentLearn,
    name: 'assessmentLearn',
    props: true
  },
  {
    path: '/course/:uuid/learn/:entityType/:entityUuid/assessment/:sessionId/selective',
    component: components.AssessmentLearnSR,
    name: 'assessmentLearnSR',
    props: true
  },
  {
    path: '/course/:uuid/learn/:entityType/:entityUuid/assessment/:sessionId/instructor',
    component: components.AssessmentLearnInstructor,
    name: 'assessmentLearnInstructor',
    props: true
  },
  {
    path: '/course/:uuid/result/:entityType/:entityUuid',
    component: components.EntityResult,
    name: 'entityResult',
    props: true
  },
  {
    path: '/course/:uuid/result/:entityType/:entityUuid/selective',
    component: components.EntityResultSR,
    name: 'entityResultSR',
    props: true
  },
  {
    path: '/course/:uuid/myReport/:entityId',
    component: components.StudentMyReport,
    name: 'myReport',
    props: true
  },
  {
    path: '/course/:uuid/classReport/:competencyId',
    component: components.ClassReport,
    name: 'classReport',
    props: true
  },
  {
    path: '/course/:uuid/masterObservationReport',
    component: components.MasterObservationReport,
    name: 'masterObservationReport',
    props: true
  },
  {
    path: '/course/:uuid/learnerObservationReport',
    component: components.LearnerObservationReport,
    name: 'learnerObservationReport',
    props: true
  },
  {
    path: '/masterCourse/create',
    component: components.CourseCreate,
    name: 'courseCreate',
    props: true
  },
  {
    path: '/masterCourse/:uuid/edit',
    component: components.CourseCreate,
    name: 'courseEdit',
    props: true
  },
  {
    path: '/courseSection/create',
    component: components.CourseSectionCreate,
    name: 'courseSectionCreate',
    props: true
  },
  {
    path: '/courseSection/:uuid/edit',
    component: components.CourseSectionCreate,
    name: 'courseSectionEdit',
    props: true
  },
  {
    path: '/courseSection/upload',
    component: components.CourseSectionUpload,
    name: 'courseSectionUpload',
    props: true
  },
  {
    path: '/course/:uuid/enroll/student',
    component: components.EnrollStudent,
    name: 'enrollStudent',
    props: true
  },
  {
    path: '/course/:uuid/enroll/observer',
    component: components.EnrollObserver,
    name: 'enrollObserver',
    props: true
  },
  {
    path: '/course/:uuid/enroll/instructor',
    component: components.EnrollInstructor,
    name: 'enrollInstructor',
    props: true
  },
  {
    path: '/course/:uuid/enroll/curator',
    component: components.EnrollCurator,
    name: 'enrollCurator',
    props: true
  },
  {
    path: '/course/:uuid/admin/enroll',
    component: components.Enroll,
    name: 'enrollmentPage',
    props: true
  },
  {
    path: '/courseSectionManagement',
    component: components.CourseList,
    name: 'courseList',
    props: true
  },
  {
    path: '/master/:uuid/sections',
    component: components.MasterSectionList,
    name: 'masterSectionList',
    props: true
  },
  {
    path: '/myCourseSections',
    component: components.MyCourseSections,
    name: 'myCourseSections',
    props: true
  },
  {
    path: '/competencyManagement',
    component: components.CompetencyTreeList,
    name: 'competencyTreeList',
    props: true
  },
  {
    path: '/competencyManagement/upload',
    component: components.CompetencyTreeUpload,
    name: 'competencyTreeUpload'
  },
  {
    path: '/course/:uuid/learn/:entityType/assessment/:entityUuid/selective',
    component: components.QuestLearn,
    name: 'questLearn',
    props: true
  },
  {
    path: '/channel/:uuid',
    component: components.CourseSectionChannel,
    name: 'courseSectionChannel',
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/app/course/routes.js